import {
  Martini,
  Wine,
  Building2,
  Trophy,
  Flag,
  Gem,
  Sparkles,
  Music,
  ClipboardList,
  Gauge,
  Award,
  Layers,
  Globe,
  ShieldCheck,
  Landmark,
  Heart,
  Store,
  Users,
  PartyPopper,
  Hotel,
  Search,
  PenTool,
  Hammer,
  Truck,
} from "lucide-react";

export const IMAGES = {
  logoGolf:
    "https://customer-assets.emergentagent.com/job_a20e3b34-7ea4-4048-9079-0f4f493f284b/artifacts/td7t34il_97809847-B21E-498C-93E6-8C2B5B44A496.PNG",
  heroMartini:
    "https://static.prod-images.emergentagent.com/jobs/a20e3b34-7ea4-4048-9079-0f4f493f284b/images/43d826294d3a13dd4af09fcbe22a2dfe59499fb8dd9da071a4a57d2b3856fb2c.png",
  pour:
    "https://static.prod-images.emergentagent.com/jobs/a20e3b34-7ea4-4048-9079-0f4f493f284b/images/71acd829768eb30e778b0d06f2c3d22081ad05bdda248481006a6f9f2724b419.png",
  volumeBar:
    "https://static.prod-images.emergentagent.com/jobs/a20e3b34-7ea4-4048-9079-0f4f493f284b/images/84f45abfe65e291324a3bb26ec670c2c7450103a8dd41af864a71a09ba8c3e3c.png",
  craftCocktails:
    "https://static.prod-images.emergentagent.com/jobs/a20e3b34-7ea4-4048-9079-0f4f493f284b/images/41ca122b6cab038c47deb260b6a6a721a341a6fd01deea7a0e8cf34dda8115e1.png",
  corporateBar:
    "https://static.prod-images.emergentagent.com/jobs/a20e3b34-7ea4-4048-9079-0f4f493f284b/images/87a715a346302e68792b9141f77477d2eabb86412fee3ff33f7b998d3d82a850.png",
  stadium:
    "https://images.unsplash.com/photo-1522778119026-d647f0596c20?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  golf:
    "https://images.unsplash.com/photo-1696104470342-b1ed3afe8381?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  festival:
    "https://images.unsplash.com/photo-1459749411175-04bf5292ceea?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

export const NAV_LINKS = [
  { label: "Services", href: "#services" },
  { label: "Why", href: "#why" },
  { label: "Events", href: "#events" },
  { label: "Process", href: "#process" },
  { label: "About", href: "#about" },
];

export const HERO_SPECIALTIES = [
  "Espresso Martini Bars",
  "Craft Cocktail Activations",
  "Corporate",
  "Sporting Events",
  "Golf",
  "Festivals",
  "Brand Activations",
  "Private Events",
];

export const TRUSTED_BY = [
  "Corporate Events",
  "Country Clubs",
  "Golf Tournaments",
  "Professional Sporting Events",
  "Hospitality Groups",
  "Luxury Private Events",
];

export const TRUST_STATS = [
  { value: "30+", label: "Years Hospitality Experience" },
  { value: "25,000+", label: "Espresso Martinis Served" },
  { value: "Nationwide", label: "Beverage Activations" },
  { value: "High-Volume", label: "Event Systems" },
];

export const SERVICES = [
  { icon: Martini, title: "Espresso Martini Experiences", copy: "Our signature: luxury Espresso Martini bars built to serve premium, handcrafted martinis at high volume without losing presentation." },
  { icon: Wine, title: "Custom Craft Cocktail Activations", copy: "Modular systems that execute virtually any premium craft cocktail program at scale, tailored to your brand and event." },
  { icon: Building2, title: "Corporate Hospitality", copy: "Elevated beverage experiences for conferences, launches, premium suites and executive events." },
  { icon: Trophy, title: "Sporting Events", copy: "High-throughput service engineered for arenas and stadiums, built for the pace of a sold-out house." },
  { icon: Flag, title: "Golf Tournaments", copy: "On-course and clubhouse activations that keep the energy elevated through championship weekends." },
  { icon: Gem, title: "Luxury Private Events", copy: "Discreet, refined service for weddings, galas and private celebrations of any size." },
  { icon: Sparkles, title: "Brand Activations", copy: "High-visibility experiences engineered to become the moment guests talk about — and post." },
  { icon: Music, title: "Festival Beverage Experiences", copy: "Large-scale, fast-moving beverage operations built for heavy footfall and rapid repeat service." },
  { icon: ClipboardList, title: "Large-Scale Beverage Consulting", copy: "We design and operate the systems, menus and teams behind world-class beverage programs." },
];

export const WHY_GOOD_SHOT = [
  { icon: Sparkles, title: "Luxury Presentation", copy: "Every serve is finished to a premium standard. Presentation is never sacrificed for speed." },
  { icon: Gauge, title: "Fast High-Volume Service", copy: "Purpose-built systems keep lines moving and output high, even at peak demand." },
  { icon: Award, title: "30+ Years Hospitality Leadership", copy: "Decades of operational experience behind every activation we design and run." },
  { icon: Layers, title: "Scalable Beverage Systems", copy: "Modular builds and workflows that scale from intimate events to stadium crowds." },
  { icon: Globe, title: "Nationwide Event Capability", copy: "Deployable anywhere in the country, executed to the same standard every time." },
  { icon: ShieldCheck, title: "Trusted Operational Expertise", copy: "Trained teams and proven processes that deliver flawless execution, event after event." },
];

export const VOLUME_PILLARS = [
  { icon: Layers, title: "Systems & Workflow", copy: "A repeatable, purpose-built service model — not a single bartender. Trained teams and refined workflows keep output high from first guest to last call." },
  { icon: Gauge, title: "Throughput & Consistency", copy: "Standardized execution means every serve meets the same premium spec at any volume, at any venue, across every market we operate in." },
  { icon: Sparkles, title: "Guest Experience", copy: "Pace and presentation are never traded off. Every interaction is engineered to feel considered, elevated and unmistakably premium." },
];

export const VOLUME_STATS = [
  { value: "Nationwide", label: "Deployment" },
  { value: "Modular", label: "Systems" },
  { value: "Peak", label: "Throughput" },
  { value: "Premium", label: "Presentation" },
];

export const EVENTS_WE_SERVE = [
  { icon: Building2, label: "Corporate Events" },
  { icon: Trophy, label: "Professional Sporting Events" },
  { icon: Flag, label: "Golf Tournaments" },
  { icon: Landmark, label: "Country Clubs" },
  { icon: Heart, label: "Luxury Weddings" },
  { icon: Music, label: "Festivals" },
  { icon: Store, label: "Trade Shows" },
  { icon: Users, label: "Conventions" },
  { icon: PartyPopper, label: "Private Parties" },
  { icon: Hotel, label: "Hospitality Groups" },
];

export const USE_CASES = [
  {
    id: "stadiums",
    overline: "01 — Environments",
    title: "Stadiums & Arenas",
    copy: "Turnkey premium beverage activations engineered for the pace of a sold-out house. Concourse programs, premium clubs and suite service — executed to a national standard for stadium operators and venue managers.",
    image: "stadium",
    align: "left",
  },
  {
    id: "golf",
    overline: "02 — On Course",
    title: "Sporting Events & Golf",
    copy: "From championship weekends to hospitality tents, we deliver elevated service that fits the tournament and the crowd — built for tournament directors and sponsors who expect flawless execution.",
    campaign: "KEEP YOUR DAY ON COURSE.",
    image: "golf",
    align: "right",
    showGolfLogo: true,
  },
  {
    id: "festivals",
    overline: "03 — Live",
    title: "Festivals & Brand Activations",
    copy: "High-visibility, high-throughput activations designed to become the moment of the event. Built for footfall, engineered for scale and made for the feed.",
    image: "festival",
    align: "left",
  },
  {
    id: "corporate",
    overline: "04 — Private",
    title: "Corporate & Luxury Hospitality",
    copy: "Refined beverage activations for galas, launches, premium suites and private celebrations. Discreet, precise and executed to the standards hospitality executives and corporate planners demand.",
    image: "corporateBar",
    align: "right",
  },
];

export const PROCESS = [
  { icon: Search, step: "01", title: "Consult", copy: "We learn your event, goals, venue and guest experience." },
  { icon: PenTool, step: "02", title: "Design", copy: "We design the bar, menu and activation around your brand." },
  { icon: Hammer, step: "03", title: "Build", copy: "We build the modular systems and staffing plan to spec." },
  { icon: Truck, step: "04", title: "Deploy", copy: "We deploy nationwide, ready for the pace of your event." },
  { icon: Martini, step: "05", title: "Serve", copy: "We serve premium cocktails at scale with flawless presentation." },
];

export const PORTFOLIO = [
  { title: "Stadium Series", tag: "Arena Activation", image: "volumeBar", size: "lg" },
  { title: "Championship Sunday", tag: "Golf Tournament", image: "golf", size: "sm" },
  { title: "Mainstage Nights", tag: "Music Festival", image: "festival", size: "sm" },
  { title: "The Gala", tag: "Corporate Hospitality", image: "corporateBar", size: "sm" },
  { title: "Craft At Scale", tag: "Cocktail Activation", image: "craftCocktails", size: "sm" },
  { title: "Signature Serve", tag: "Luxury Private Event", image: "heroMartini", size: "lg" },
];

export const ABOUT = {
  name: "Lance Sigler",
  role: "Founder",
  body: [
    "Good Shot Espresso creates premium beverage activations for corporate events, sporting events, golf tournaments, luxury hospitality, festivals, conventions, private events and national brand experiences.",
    "Our proprietary systems are engineered for speed, consistency and exceptional guest presentation while maintaining handcrafted quality.",
    "While Espresso Martinis are our signature experience, our modular beverage systems allow us to execute virtually any premium craft cocktail program at scale.",
  ],
  stats: [
    { value: "30+", label: "Years Hospitality Experience" },
    { value: "25,000+", label: "Espresso Martinis Served" },
    { value: "High-Volume", label: "Event Systems" },
    { value: "Nationwide", label: "Event Capability" },
  ],
};

export const EVENT_TYPES = [
  "Espresso Martini Bar",
  "Custom Craft Cocktail Activation",
  "Corporate Event",
  "Professional Sporting Event",
  "Golf Tournament",
  "Festival",
  "Brand Activation",
  "Luxury / Private Event",
  "Convention / Trade Show",
  "Other",
];

export const ATTENDANCE_RANGES = [
  "Under 500",
  "500 – 2,000",
  "2,000 – 10,000",
  "10,000 – 50,000",
  "50,000+",
];

export const CONTACT = {
  phone: "248-840-0102",
  phoneHref: "tel:+12488400102",
  email: "lance@goodshotespresso.com",
  instagram: "GoodShotEspresso",
  instagramHref: "https://instagram.com/GoodShotEspresso",
};
